// service worker state is not persisted. it is filtered out from transforms.ts
export type SWState = {
  updateAvailable: boolean;
};

export const initialState: SWState = {
  updateAvailable: false,
};
